export const enMessages = {
  common: {
    back: 'Back',
    continue: 'Continue',
    pleaseWait: 'Please wait...',
    edit: 'Edit',
    exit: 'Exit',
    close: 'Close',
    notAnswered: '— Not answered',
    emptyValue: '---',
    backToSummary: 'Back to summary',
    toSummary: 'Go to summary',
    toFinalSummary: 'Go to final summary',
    selectPlaceholder: 'Select...',
    selectRegion: 'Select region...',
    selectIncome: 'Select income range...',
    displayDescriptionPrefix: 'Display description:',
    weightUnit: 'kg',
    viewFinalSummary: 'View final summary',
    redo: 'Retake',
    start: 'Start',
    resultPrefix: 'Result:',
    supplementDetails: 'Add details',
    supplementDone: '✅ Added (Edit)',
    takeQuiz: 'Take quiz',
    retakeQuiz: 'Retake quiz',
    viewResultAndShare: 'View result & share',
    submitting: 'Submitting…',
    submittingData: 'SUBMITTING DATA...',
    confirmSubmit: 'CONFIRM & SUBMIT PROFILE',
    join: 'JOIN',
    logout: 'Exit',
  },

  logo: {
    dating: 'FIND LOVE / LIFE PARTNER',
    quizPrefix: 'Date.',
    quizHighlight: 'Mut',
    quizSuffix: '.Vn',
  },

  progress: {
    introHint: 'Fill in your details if you truly want to connect with the right guy for you',
  },

  login: {
    title: 'Join / Sign In',
    titleQuiz: 'Create profile / Sign in',
    quizHint: 'Already took a quiz? Sign up to save your results and get matched.',
    backToQuiz: 'Back to quiz',
    emailLabel: 'Email or phone number',
    emailPlaceholder: 'e.g. 0912345678/you@gmail.com',
    pinLabel: 'PIN (profile security)',
    pinPlaceholder: '******',
    tryQuizFirst: 'Try a quiz first — no sign-up required',
  },

  steps: {
    step1: {
      title: 'STEP 1: BASIC INFO',
      privacyNote: 'All your information is kept safe and confidential.',
      fullName: 'Full name',
      nickname: 'Nickname',
      dob: 'Date of birth',
      dobPlaceholder: 'DD/MM/YYYY (e.g. 20/01/2000)',
      city: 'Province / City',
      address: 'District & full address',
      addressPlaceholder: 'e.g. District 1, Le Loi Street...',
    },
    step2: {
      title: 'STEP 2: PORTRAIT',
      height: 'Height (cm)',
      heightPlaceholder: '175',
      weight: 'Weight (kg)',
      weightPlaceholder: '70',
      bodyType: 'Body type',
      education: 'Education',
      income: 'Monthly income',
      job: 'Job & current position',
      jobPlaceholder: 'e.g. IT Manager at ACB Bank',
      currentStatus: 'Current status:',
      livingSpace: 'Current living situation:',
    },
    step3: {
      title: 'STEP 3: IDENTITY',
      orientation: 'Orientation',
      role: 'Role',
      comingOut: 'Coming out level',
      relationship: 'Relationship you are looking for',
      personality: 'Standout personality traits',
      pros: 'Strengths',
      cons: 'Weaknesses',
      substances: 'Substances & habits',
    },
    step4: {
      title: 'STEP 4: DEPTH',
      energy: 'Energy',
      lifestyle: 'Lifestyle',
      hobbies: 'Hobbies',
      loveLanguage: 'Love language',
      futurePlans: 'Future plans',
      futureKids: 'View on children',
      financeShared: 'Shared finances',
      financeMindset: 'Money mindset',
      sexView: 'View on sex',
    },
    step5: {
      title: 'STEP 5: PREFERENCES',
      partnerAge: 'Preferred partner age range',
      partnerRole: "Partner's role",
      partnerBody: 'Ideal body type',
      priority: 'Top priority',
      redflag: 'Absolute dealbreakers',
      messageToAdmin: 'Most important message for us',
      messageToAdminPlaceholder:
        'Your strengths, special interests, or the ideal match you hope to connect with',
    },
    step6: {
      title: 'Step 6: Profile verification',
      avatar: 'Personal photos (you can select multiple)',
      avatarUploading: 'Processing image...',
      avatarUpload: '📸 Tap to add more photos',
      socialLink: 'Personal Facebook / Instagram link',
      socialLinkPlaceholder: 'https://facebook.com/yourprofile',
      idCard: 'ID card photo (front side)',
      idCardSubtitle: 'Optional — helps verify identity and prevent scams.',
      idCardUploading: 'Processing image...',
      idCardUploaded: '✅ Photo uploaded successfully',
      idCardUpload: '📸 Tap to choose/take a photo',
    },
    step8: {
      title: 'STEP 8: PSYCHOLOGY',
      description:
        'Share more so our team can better understand your emotional state and readiness.',
    },
    step9: {
      title: 'STEP 9: REAL LIFE',
      description: 'Pets, religion, and health — factors that affect living together.',
    },
    step10: {
      title: 'STEP 10: SEX & HEALTH',
      description: 'Bedroom views and preferences — strictly confidential.',
    },
    step11: {
      title: 'STEP 11: PRESSURE & BARRIERS',
      description: 'How family and society affect your romantic life.',
    },
    step12: {
      title: 'STEP 12: OPEN-ENDED QUESTIONS',
      description:
        'Write a few sentences in your own words so we can better understand your vibe and personality.',
      answerPlaceholder: 'Write your answer here...',
    },
  },

  summary: {
    title: 'PROFILE SUMMARY',
    hint: 'Please review the information below carefully. Tap',
    hintEdit: '[Edit]',
    hintSuffix: 'on each section to make changes.',
    section1Title: '📌 1. Basic Information',
    section1TitleShort: '📌 Info',
    section2Title: '👤 2. Portrait & Background',
    section2TitleShort: '👤 Portrait',
    section3Title: '🌈 3. Identity & Personality',
    section3TitleShort: '🌈 Identity',
    section4Title: '🌌 4. Depth & Lifestyle',
    section4TitleShort: '🌌 Lifestyle',
    section5Title: '🎯 5. Partner Preferences',
    section5TitleShort: '🎯 Partner',
    section6Title: '📸 6. Verification',
    section6TitleShort: '📸 Verify',
    section7Title: '🧩 7. Optional extras & quizzes',
    section7Description:
      'Take a quick quiz so we understand you better; you can download result images to share if you like.',
    deepQuestionsTitle: '💬 Deeper Questions',
    deepQuestionsDescription:
      'Share more about daily habits and how you handle conflict.',
    personalityQuizTitle: '🎭 Dating Personality Quiz',
    personalityQuizDescription:
      'Discover your dating personality type: thoughtful, warm, or romantic?',
    frozenHeartTitle: '🧊 Frozen Heart',
    frozenHeartDescription: 'Decode the single-life curse — 10 questions, get a Story card to share.',
    fullName: 'Full name:',
    dob: 'Date of birth:',
    contact: 'Contact:',
    address: 'Address:',
    heightWeight: 'Height/Weight:',
    heightWeightValue: '{height}cm{weightPart}',
    weightPart: ' - {weight}kg',
    bodyType: 'Body type:',
    education: 'Education:',
    job: 'Job:',
    income: 'Income:',
    status: 'Status:',
    orientationRole: 'Orientation & role:',
    comeOut: 'Coming out:',
    seekingRelationship: 'Relationship sought:',
    personalityTraits: 'Personality traits:',
    pros: 'Strengths:',
    cons: 'Weaknesses:',
    substances: 'Substances:',
    energyLifestyle: 'Energy & lifestyle:',
    kidsView: 'View on children:',
    hobbies: 'Hobbies:',
    loveLanguage: 'Love language:',
    futurePlans: 'Future plans:',
    finance: 'Finance views:',
    sexView: 'View on sex:',
    priority: 'Top priority:',
    partnerPrefs: 'Partner prefs (age, role, body):',
    redflag: 'Red flags (absolute dealbreakers):',
    message: 'Personal note:',
    social: 'Social media:',
    personalPhotos: 'Personal photos:',
    idCardSecure: 'ID card (secure):',
    idCardBadge: 'ID',
  },

  summaryFull: {
    title: 'FULL SUMMARY',
    hint: 'Review all information. Tap',
    hintEdit: '[Edit]',
    hintSuffix: 'on each section to update.',
    psychTitle: '🧠 Psychology & Emotions',
    psychTitleShort: '🧠 Psychology',
    practicalTitle: '🏠 Real Life',
    practicalTitleShort: '🏠 Real life',
    sexTitle: '❤️ Sex & Health',
    sexTitleShort: '❤️ Sex & health',
    pressureTitle: '👥 Pressure & Barriers',
    pressureTitleShort: '👥 Pressure',
    narrativeTitle: '✍️ Open-Ended EQ Questions',
    narrativeTitleShort: '✍️ Narrative',
    quizTitle: '🧩 Quizzes',
    personalityQuizLabel: '🎭 Dating Personality',
    frozenHeartLabel: '🧊 Frozen Heart',
    backToFirstSummary: '← Back to first summary',
  },

  quiz: {
    heroTitle: 'Discover yourself',
    heroDescription:
      'Two short quizzes — no sign-up needed. When done, download a Story image and share if you like.',
    heroNote: 'For fun & reflection, not a substitute for therapy.',
    loggedInAs: 'Signed in as:',
    viewProfile: 'View profile',
    createPrivateProfile: 'Want to get matched? Create a private profile',
    alreadyHaveProfile: 'Already have a profile — sign in',
    saveQuizToProfile: 'Save quiz results to profile',
    backToQuizPage: '⬅️ Back to quiz page',
    frozenHeart: {
      title: 'Frozen Heart',
      description:
        'Decode the single-life curse — get a unique profile card to flex or post on Story.',
      meta: '10 questions · ~90 seconds',
      decodeNow: 'Decode now',
    },
    personality: {
      title: 'Love Style',
      description:
        'Flex, flirt, or heal — see if you are CEO of romance, story king, family bear, or salty vitamin.',
      meta: '5 questions · about 1 minute',
    },
    progress: 'Question {current} / {total}',
    closeAriaLabel: 'Close',
    joinDating: 'Join dating',
  },

  share: {
    nameField: {
      label: 'Display name on Story image',
      placeholder: 'e.g. Alex, J.Smith...',
      hint: 'Nickname / home name only — do not use full legal name',
      requiredHint: ' · Required before sharing image',
    },
    avatarPicker: {
      label: 'Avatar on share card',
      ariaLabel: 'Avatar on share card',
      personal: {
        title: 'Personal photo',
        description: 'Use your profile photo',
      },
      default: {
        title: 'Quiz icon',
        description: 'Use the default result emoji',
      },
    },
    aspectPicker: {
      label: 'Export aspect ratio',
      ariaLabel: 'Export aspect ratio',
      story: {
        ratioLabel: '9:16',
        platformLabel: 'Story / Reels',
        exportLabel: '1080×1920',
      },
      feed: {
        ratioLabel: '3:4',
        platformLabel: 'Facebook / Instagram / Threads',
        exportLabel: '1080×1440',
      },
    },
    actions: {
      share: 'Share',
      download: 'Download',
      generating: 'Generating image…',
      downloadWithSpec: 'Download {ratio} image ({exportLabel})',
      copyCaption: 'Copy share caption',
      captionCopied: 'Caption copied',
      nativeShareHintPrefix: 'Choose',
      nativeShareSave: 'Save image',
      nativeShareGooglePhotos: 'Google Photos',
      nativeShareInstagram: 'Instagram',
      nativeShareHintSuffix: 'in the menu — no need to go through Downloads',
    },
    caption: {
      personalityQuizLabel: 'Love Style',
      singleQuizLabel: 'Frozen Heart',
      scoreFrozenHeart: 'heart temperature {temperature} ({temperatureLabel})',
      scorePersonality: 'match {percent}%, group {typeKey}',
      template:
        'I just took the "{quizLabel}" quiz on {siteName} — result: {shareTitle} ({scoreLine}).\n"{shareHook}"\nSee which group you belong to: {quizUrl}',
    },
    card: {
      personalityLabel: 'Love Style',
      singleLabel: 'Frozen Heart',
      frozenPercent: 'Frozen',
      temperature: 'Temperature:',
      qrSubtitlePersonality: 'Scan to take the quiz',
      qrSubtitleSingle: 'Decode the single-life curse',
      footerTagline: 'Find love / Life partner',
      zodiacPrefix: '',
    },
  },

  alerts: {
    apiKeyNotConfigured: 'Image upload API key is not configured. Please contact admin.',
    imageProcessFailed: 'Could not process image. Please try again.',
    imageProcessNetworkError: 'Could not process image. Please check your network connection.',
    genericError: 'Something went wrong. Please try again later.',
    networkError: 'Something went wrong. Please check your network connection.',
    quizSavedLocally:
      'Quiz results saved on your device. Sign up with email + PIN to submit your profile and get matched!',
    shareNameRequired: 'Please enter a display name for the Story image before sharing.',
    imageGenerateFailed:
      'Could not generate the image automatically. Please take a screenshot of this result.',
    maxSelections: 'You can select at most {max} options.',
    confirmExit: 'Are you sure you want to exit?',
  },

  success: {
    title: 'Profile Submitted Successfully!',
    body: 'Your profile has been added to our private system. All temporary data in this browser has been cleared for your security.',
    hint: 'Next time, just enter your',
    hintCredentials: 'email and PIN',
    hintSuffix: 'to view this profile again.',
    backHome: 'Back to home',
  },

  publicCards: {
    title: 'Card Collection',
    subtitle: 'All quiz cards created by this user',
    loading: 'Loading...',
    notFound: 'Profile or cards not found.',
    backToQuiz: 'Take the quiz yourself',
    infoTitle: 'Public Info',
    cardsTitle: 'Created Cards',
    cardsEmpty: 'No cards created yet.',
    cardsEmptyHint: 'Complete a quiz to generate beautiful share cards.',
    verified: 'CCCD Verified',
    notVerified: 'Not verified',
    roleEmpty: 'Not set',
    cardType: {
      personality: 'Dating Style',
      single: 'Frozen Heart',
    },
    meta: {
      created: 'Created',
      aspect: 'Ratio',
    },
    viewOriginal: 'View original',
    close: 'Close',
  },
} as const;